import { courseLicenseTemplateApi } from '@/api/course-license-template.api';
import {
  CourseLicensePreviewRequestDTO,
  CreateUpdateCourseLicenseTemplateApiDTO,
  ValidateLicenseTemplateReplacersDTO
} from '@/jbi-shared/dto/jtms.dtos';
import { Store } from 'vuex';
import {
  CourseLicenseTemplateQueryParams,
  CourseLicenseTemplateState,
  UpdateCourseLicenseTemplateApiDTO
} from './course-license-template.types';

export const courseLicenseTemplateActions = {
  async getAvailableReplacers(store: Store<CourseLicenseTemplateState>) {
    try {
      store.commit('GET_AVAILABLE_REPLACERS_LOADING');

      const { data } = await courseLicenseTemplateApi.getAvailableReplacers();

      store.commit('GET_AVAILABLE_REPLACERS_SUCCESS', data);

      return data;
    } catch (error) {
      store.commit('GET_AVAILABLE_REPLACERS_ERROR', error);
      throw error;
    }
  },

  async validateLicenseTemplatePlaceholders(
    store: Store<CourseLicenseTemplateState>,
    payload: ValidateLicenseTemplateReplacersDTO
  ) {
    try {
      store.commit('VALIDATE_LICENSE_TEMPLATE_PLACEHOLDERS_LOADING');

      const {
        data
      } = await courseLicenseTemplateApi.validateLicenseTemplatePlaceholders(
        payload
      );

      store.commit('VALIDATE_LICENSE_TEMPLATE_PLACEHOLDERS_SUCCESS', data);
    } catch (error) {
      store.commit('VALIDATE_LICENSE_TEMPLATE_PLACEHOLDERS_ERROR', error);
      throw error;
    }
  },

  async generateCourseLicensePreviewFromTemplate(
    store: Store<CourseLicenseTemplateState>,
    payload: CourseLicensePreviewRequestDTO
  ) {
    try {
      store.commit('GENERATE_COURSE_LICENSE_PREVIEW_LOADING');

      const {
        data
      } = await courseLicenseTemplateApi.generateCourseLicensePreviewFromTemplate(
        payload
      );

      store.commit('GENERATE_COURSE_LICENSE_PREVIEW_SUCCESS', data);
    } catch (error) {
      store.commit('GENERATE_COURSE_LICENSE_PREVIEW_ERROR', error);
      throw error;
    }
  },

  async getPaginatedCourseLicenseTemplate(
    store: Store<CourseLicenseTemplateState>,
    payload: CourseLicenseTemplateQueryParams
  ) {
    try {
      store.commit('GET_PAGINATED_COURSE_LICENSE_TEMPLATES_LOADING');

      const {
        data
      } = await courseLicenseTemplateApi.getPaginatedCourseLicenseTemplate(
        payload
      );

      store.commit('GET_PAGINATED_COURSE_LICENSE_TEMPLATES_SUCCESS', data);

      return data;
    } catch (error) {
      store.commit('GET_PAGINATED_COURSE_LICENSE_TEMPLATES_ERROR', error);
      throw error;
    }
  },

  async createCourseLicenseTemplate(
    store: Store<CourseLicenseTemplateState>,
    payload: CreateUpdateCourseLicenseTemplateApiDTO
  ) {
    try {
      store.commit('CREATE_COURSE_LICENSE_TEMPLATE_LOADING');

      await courseLicenseTemplateApi.createCourseLicenseTemplate(payload);

      store.commit('CREATE_COURSE_LICENSE_TEMPLATE_SUCCESS');
    } catch (error) {
      store.commit('CREATE_COURSE_LICENSE_TEMPLATE_ERROR', error);
      throw error;
    }
  },

  async updateCourseLicenseTemplate(
    store: Store<CourseLicenseTemplateState>,
    payload: UpdateCourseLicenseTemplateApiDTO
  ) {
    try {
      store.commit('UPDATE_COURSE_LICENSE_TEMPLATE_LOADING');

      await courseLicenseTemplateApi.updateCourseLicenseTemplate(payload);

      store.commit('UPDATE_COURSE_LICENSE_TEMPLATE_SUCCESS');
    } catch (error) {
      store.commit('UPDATE_COURSE_LICENSE_TEMPLATE_ERROR', error);
      throw error;
    }
  },

  async deleteCourseLicenseTemplate(
    store: Store<CourseLicenseTemplateState>,
    id: number
  ) {
    try {
      store.commit('DELETE_COURSE_LICENSE_TEMPLATE_LOADING');

      await courseLicenseTemplateApi.deleteCourseLicenseTemplate(id);

      store.commit('DELETE_COURSE_LICENSE_TEMPLATE_SUCCESS');
    } catch (error) {
      store.commit('DELETE_COURSE_LICENSE_TEMPLATE_ERROR', error);
      throw error;
    }
  }
};
